const hexToRgb = hex => {
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);

  // return result
  //   ? {
  //       r: parseInt(result[1], 16),
  //       g: parseInt(result[2], 16),
  //       b: parseInt(result[3], 16),
  //     }
  //   : {
  //       r: 0,
  //       g: 0,
  //       b: 0,
  //     };

  return ['r', 'g', 'b'].reduce((acc, curr, i) => {
    return {
      ...acc,
      [curr]: !result ? 0 : parseInt(result[i + 1], 16),
    };
  }, {}) as any;
};

export default hexToRgb;
